import { render } from "./PuntoCyanStreamlined.vue?vue&type=template&id=6f32444a&scoped=true"
import script from "./PuntoCyanStreamlined.vue?vue&type=script&lang=ts"
export * from "./PuntoCyanStreamlined.vue?vue&type=script&lang=ts"

import "./PuntoCyanStreamlined.vue?vue&type=style&index=0&id=6f32444a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6f32444a"

export default script